export default __webpack_public_path__ + "static/media/EMILY LOVER SAMPLE.d88afee6.wav";